import styled from "@emotion/styled";

export const Container = styled.section`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background: rgb(253, 160, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const AuditoTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin-top: 20px;
`;

export const NotAuth = styled.div`
  display: flex;
  flex-align: center;
  gap: 5px;
  justify-content: center;
  align-items: center;
`;

export const Box = styled.div`
  width: 500px;
  border-top: 1px solid rgb(255, 189, 75)
  border-radius: 5px;
  padding: 10px;
  margin-top: 30px;
  text-align: center;
  font-size: 16px;
`;

export default Container;
